import { localStorageService } from 'service/storage';
import { logger } from '@nykaa/logger';

const CART_QTY = 'cart_qty';

export const deleteCartQtyLocalStorage = () => {
  localStorageService.removeItem(CART_QTY);
};

export const saveCartQtyLocalStorage = (items: Record<string, number>) => {
  try {
    if (typeof window !== 'undefined') {
      localStorageService.setItem(CART_QTY, JSON.stringify(items));
    }
  } catch (error) {
    logger.error('Error saving cart quantity to localStorage:', error);
  }
};

export const loadCartQtyFromLocalStorage = (): Record<string, number> => {
  try {
    if (typeof window !== 'undefined') {
      const stored = localStorageService.getItem(CART_QTY);
      return stored ? JSON.parse(stored) : {};
    }
  } catch (error) {
    logger.error('Error loading cart quantity from localStorage:', error);
  }
  return {};
};

export const isCartQtyDataExist = (): boolean => {
  try {
    if (typeof window !== 'undefined') {
      const stored = localStorageService.getItem(CART_QTY);
      return stored ? true : false;
    }
  } catch (error) {
    logger.error('Error loading cart quantity from localStorage:', error);
  }
  return false;
};
